import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { CrowdFlowObserved } from '../../model/crowd-flow-observed';
import { WebsocketService } from '../../service/websocket.service';
import { CrowdFlowObservedState, CrowdFlowsObservedStore } from '../state/crowd-flows-observed.store';
import { AkitaCrowdFlowObservedHttpService } from './akita-http-crowdflow-observed.service';
import { UrlConfig } from '../../model/urlconfig';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CrowdFlowsObservedService extends NgEntityService<CrowdFlowObservedState> implements UrlConfig {

  constructor(
    protected store: CrowdFlowsObservedStore,
    private crowdFlowHttpService: AkitaCrowdFlowObservedHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('CrowdFlowObserved')
      .pipe(untilDestroyed(this))
      .subscribe((data: CrowdFlowObserved[]) => this.store.upsertMany(data));
  }

  getAll() {
    this.crowdFlowHttpService.getAll().subscribe(crowdFlows => this.store.add(crowdFlows));
  }

  getById(id: ID) {
    this.crowdFlowHttpService.loadById(id).subscribe(crowdFlows => this.store.add(crowdFlows));
  }
  updateEntitiesUrl(newUrl: string) {
    this.crowdFlowHttpService.setEntitiesUrl(newUrl);
  }

}
